/**
 * DownloadCircleIcon Component
 * Download icon inside a circular background for row actions.
 */

import React from 'react';
import type { IconProps } from './types';
import { colors } from '../colors';

interface DownloadCircleIconProps extends IconProps {
  /** Background circle color */
  bgColor?: string;
}

const DownloadCircleIcon: React.FC<DownloadCircleIconProps> = ({
  size = 24,
  color = colors.neutral.white,
  bgColor = colors.background[600],
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {bgColor && bgColor !== "transparent" && (
      <rect width={24} height={24} rx={12} fill={bgColor} />
    )}
    <path
      d="M15.25 10.28c2 .17 2.817 1.2 2.817 3.45v.072c0 2.483-.995 3.478-3.478 3.478h-5.18c-2.483 0-3.477-.995-3.477-3.478v-.072c0-2.234.805-3.262 2.772-3.444M12 5.5v8.14"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.35 12.1L12 14.45 9.65 12.1"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadCircleIcon;
